package frontend.lib

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import kotlin.coroutines.*
import kotlin.js.Promise

suspend fun <T> Promise<T>.await(): T = suspendCoroutine { cont ->
    then({ cont.resume(it) }, { cont.resumeWithException(it) })
}

fun isEthereumAvailable(): Boolean {
    return js("typeof ethereum") == "object"
}

fun isMetaMaskAvailable(): Boolean {
    return isEthereumAvailable() && ethereum.isMetaMask;
}

external interface RequestArguments {
    var method: String
    var params: Any?
    var value: Any?
    var from: Any?
    var to: Any?
}

fun RequestArguments(): RequestArguments = js("{}")

external interface TransactionParams {
    var from: String
    var to: String
    var value: String
}
fun TransactionParams(): TransactionParams = js("{}")

external class ethereum {
    companion object {
        val isMetaMask: Boolean
        fun isConnected(): Boolean
        suspend fun enable(): Promise<Unit>
        suspend fun request(params: RequestArguments): Promise<dynamic>
    }
}

class MetaMask {
    companion object {
        suspend fun getAccounts(): Array<String> {
            val accounts = ethereum.request(RequestArguments().apply {
                method = "eth_requestAccounts"
            }).await()

            println(accounts)

            return accounts
        }

        suspend fun sign(message: String, account: String): String {
            val signature = ethereum.request(RequestArguments().apply {
                method = "personal_sign"
                params = arrayOf(account, message)
            }).await()

            return signature
        }

        suspend fun pay(amount: BigDecimal, fromAddress: String, toAddress: String): String {
            val weiAmount = amount.moveDecimalPoint(18).toBigInteger()
            val weiHex = "0x" + weiAmount.toString(16)

            val txHash = ethereum.request(RequestArguments().apply {
                method = "eth_sendTransaction"
                params = arrayOf(TransactionParams().apply {
                    from = fromAddress
                    to = toAddress
                    value = weiHex
                })
            }).await()

            return txHash
        }
    }
}

